import React from "react";
import Home from "./../loggedIn/Home";
import Settings from "./../loggedIn/Settings";
import RazerSkill from "./../loggedIn/RazerSkill";
import AlexaLogoDark from "assets/alexa_logo.svg";
import AlexaLogoLight from "assets/img_light_theme/alexa_logo.svg";
import RZNotificationDialog from "fragments/RZNotificationDialog";
import { AlexaCommon } from "../../utils/Common";
import { ThemeContext, themes } from "./../../theme-context";
import { LocalizationContext } from "./../../localization-context";

const autoBind = require("auto-bind");
const queryString = require("query-string");

const WithContext = (Component) => {
  return (props) => (
    <ThemeContext.Consumer>
      {(themeValue) => (
        <LocalizationContext.Consumer>
          {(value) => (
            <Component
              {...props}
              localizationContext={value}
              themeContext={themeValue}
            />
          )}
        </LocalizationContext.Consumer>
      )}
    </ThemeContext.Consumer>
  );
};

class LoggedIn extends React.Component {
  constructor(props) {
    super(props);

    this.avsWrapper = this.props.avsWrapper;
    this.avs = this.avsWrapper.avs;
    //bind this
    autoBind(this);
    let parsedHash = queryString.parse(window.location.search);

    this.state = {
      currPage: parsedHash.page,
      synapseData: null,
    };
  }
  //after dom intialized.
  componentDidMount() {
    this.subscribeEvent();
  }

  subscribeEvent() {
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.LOGIN,
      "1",
      () => this.onLoginStatusChanged
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.NAVIGATE_TO,
      "1",
      (page) => this.onPageChanged(page)
    );
  }

  onLoginStatusChanged() {
    this.forceUpdate();
  }

  onPageChanged(page) {
    if (typeof page !== "string") {
      return;
    }
    if (page.toLowerCase() === AlexaCommon.Pages.HOME) {
      this.setState({ currPage: AlexaCommon.Pages.HOME });
    } else if (page.toLowerCase() === AlexaCommon.Pages.SETTINGS) {
      this.setState({ currPage: AlexaCommon.Pages.SETTINGS });
    } else if (page.toLowerCase() === AlexaCommon.Pages.SKILLS) {
      this.setState({ currPage: AlexaCommon.Pages.SKILLS });
    }
    console.log("page change" + page);
  }

  onHandleConfirmButtonClicked(event) {
    // let razerAmazonId = localStorage.getItem("razerAmazonId");
    // console.log("confirm buttion was clicked.", razerAmazonId);
    // AlexaCommon.registerAmazonRazerIdAccountLinking(razerAmazonId,true,true)
    // .then(()=>{
    //     AlexaCommon.consoleLogDataUIImportantInfo("onHandleConfirmButtonClicked , swap AccountLinking process Success");
    // })
    // .catch(()=>{
    //     AlexaCommon.consoleLogDataUIFatalError("onHandleConfirmButtonClicked ,but swap AmazonRazerIdAccountLinking process failed");
    // })
    // .finally(()=>{
    //     this.props.handleAccountLinkConflictsNotificationClose();
    // });
  }

  onHandleCancelButtonClicked(event) {
    console.log("cancel button was clicked.");
    this.props.handleAccountLinkConflictsNotificationClose(() => {
      this.avsWrapper.logout();
    });
  }

  renderAccountLinkingConflictsDialog() {
    let theme = this.props.themeContext;
    let AlexaLogo = theme === themes.light ? AlexaLogoLight : AlexaLogoDark;
    let dialogHeaderContent = <img src={AlexaLogo} />;
    let firstParam = (
      <p key="1" className="account-linking-param">
        {this.props.localizationContext.accountLinkingConflictsDialogParam1}
      </p>
    );
    let secondParam = (
      <p key="2" className="account-linking-param">
        {this.props.localizationContext.accountLinkingConflictsDialogParam2}
      </p>
    );
    let dialogTextContent = [firstParam, secondParam];
    let dialogOkTextContent = this.props.localizationContext
      .accountLinkingConflictsDialogOK;
    let dialogCancelTextContent = this.props.localizationContext
      .accountLinkingConflictsDialogCancel;
    return (
      <RZNotificationDialog
        handleConfirmButtonClicked={this.onHandleConfirmButtonClicked}
        handleCancelButtonClicked={this.onHandleCancelButtonClicked}
        headerContent={dialogHeaderContent}
        textContent={dialogTextContent}
        okTextContent={dialogOkTextContent}
        cancelTextContent={dialogCancelTextContent}
      />
    );
  }

  render() {
    let homeDisplay = this.state.currPage === AlexaCommon.Pages.HOME;
    let settingsDisplay = this.state.currPage === AlexaCommon.Pages.SETTINGS;
    let razerSkillDisplay = this.state.currPage === AlexaCommon.Pages.SKILLS;
    let homeWrapperDisplay = this.props.isAccountLinkConflicts
      ? "none"
      : "block";
    let accountLinkingConflictDialogDisplay = this.props.isAccountLinkConflicts
      ? "block"
      : "none";
    let notificationDialog = this.renderAccountLinkingConflictsDialog();

    return (
      <div className="home-wrapper">
        <div
          className="accountLinkingOk"
          style={{ display: homeWrapperDisplay }}
        >
          {homeDisplay && <Home avsWrapper={this.avsWrapper} />}
          {settingsDisplay && <Settings avsWrapper={this.avsWrapper} />}
          {razerSkillDisplay && (
            <RazerSkill avsWrapper={this.avsWrapper}></RazerSkill>
          )}
        </div>
        <div
          className="accountLinkingNotOk"
          style={{ display: accountLinkingConflictDialogDisplay }}
        >
          {notificationDialog}
        </div>
      </div>
    );
  }
}

export default WithContext(LoggedIn);
